import React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import ReactGA from "react-ga";
import classnames from "classnames/bind";
import LinksWidget, { Col } from "./LinksWidget";
import DeferredIcon from "../../../components/deferred-icon/DeferredIcon";
import { linksList1, linksList2, linksList3, linksList4 } from "../footerLinks";
import styles from "./footer.module.scss";
import { Button } from "@aqar-app/react-ui";
import Icon from "@/components/icon";

const cx = classnames.bind(styles);

const Footer = () => {
  const router = useRouter();
  const { iframe } = router?.query;

  return (
    <div>
      <div className={cx("footer", { iframe: iframe === "1" })}>
        <div className={styles.top}>
          <div className={styles.downloadSection}>
            <Link href="/" passHref>
              <div className={styles.logo}>
                <DeferredIcon
                  type="v1/aqar-logo-vertical-v2"
                  alt="Aqar Logo"
                  width={150}
                  height={150}
                />
                <span className={styles.subtitle}>معك في رحلة العمر</span>
              </div>
            </Link>
            <div className={styles.btns}>
              <a
                href="https://play.google.com/store/apps/details?id=fm.aqar"
                target="_blank"
              >
                <button
                  onClick={() => {
                    ReactGA.event({
                      category: "download_android_footer",
                      action: "Download Android app from footer",
                    });
                  }}
                >
                  <Icon name="v1/google-play" width={120} height={40} />
                </button>
              </a>
              <a
                href="https://apps.apple.com/sa/app/id879992882"
                target="_blank"
              >
                <button
                  className={styles.footerBtn}
                  onClick={() => {
                    ReactGA.event({
                      category: "download_iphone_footer",
                      action: "Download iPhone app from footer",
                    });
                  }}
                >
                  <Icon name="v1/app-store" width={120} height={40} />
                </button>
              </a>
              <a
                href="https://appgallery.huawei.com/app/C100162543"
                target="_blank"
              >
                <button
                  onClick={() => {
                    ReactGA.event({
                      category: "download_huawei_footer",
                      action: "Download Huawei app from footer",
                    });
                  }}
                >
                  <Icon name="v1/app-gallery-v1" width={120} height={40} />
                </button>
              </a>
            </div>
          </div>
          <LinksWidget title="خيارات البحث">
            <Col links={linksList1} />
            <Col links={linksList2} />
          </LinksWidget>
          <LinksWidget title="روابط سريعة">
            <Col links={linksList3} />
            <Col links={linksList4} />
          </LinksWidget>
        </div>
        <div className={styles.bottom}>
          <div className={styles.rightSide}>
            <div className={styles.socialIcon}>
              <DeferredIcon
                alt="Fb"
                type="Facebook"
                className={styles.icon}
                onClick={() =>
                  window.open("https://www.facebook.com/aqarapp", "_blank")
                }
                width={25}
                height={25}
              />
            </div>
            <div className={styles.socialIcon}>
              <DeferredIcon
                alt="linkedin"
                type="Linkedin"
                className={styles.icon}
                onClick={() =>
                  window.open(
                    "https://www.linkedin.com/company/aqarfm/about/",
                    "_blank",
                  )
                }
                width={25}
                height={25}
              />
            </div>
            <div className={styles.socialIcon}>
              <DeferredIcon
                alt="twitter"
                type="twitter-new-2"
                className={styles.icon}
                onClick={() =>
                  window.open("https://twitter.com/aqarapp", "_blank")
                }
                width={25}
                height={25}
              />
            </div>
            <div className={styles.socialIcon}>
              <DeferredIcon
                alt="instagram"
                type="Instagram"
                className={styles.icon}
                onClick={() =>
                  window.open("https://www.instagram.com/aqarapp", "_blank")
                }
                width={25}
                height={25}
              />
            </div>
            <div className={styles.socialIcon}>
              <DeferredIcon
                alt="youtube"
                type="Youtube"
                className={styles.icon}
                onClick={() =>
                  window.open(
                    "https://www.youtube.com/channel/UCxWf_zM_FSEBaH5Z_4K8oaA/videos",
                    "_blank",
                  )
                }
                width={25}
                height={25}
              />
            </div>
            <div className={styles.socialIcon}>
              <DeferredIcon
                alt="snapchat"
                type="Snapchat"
                className={styles.icon}
                onClick={() =>
                  window.open("https://www.snapchat.com/add/aqarapp", "_blank")
                }
                width={25}
                height={25}
              />
            </div>
            <div className={styles.socialIcon}>
              <DeferredIcon
                alt="Tiktok"
                type="tiktok-2"
                className={styles.icon}
                onClick={() =>
                  window.open("https://www.tiktok.com/@aqarapp", "_blank")
                }
                width={25}
                height={25}
              />
            </div>
          </div>
          <div className={styles.leftSide}>
            <a
              href="https://ehsan.sa/FastDonation/F663F6DC6CB3F9BF6D94E7A6BAA658E9AE41AA889BF9DF3641EE295620B25612E3C0A8EDBEE37261F211E03CF47615F3"
              target="_blank"
            >
              <Button outline size="medium" className={styles.donate}>
                خدمة التبرع السريع
                <Icon name="Ehsan" width={25} height={25} />
              </Button>
            </a>
            <DeferredIcon
              alt="vat"
              type="vat_2"
              className={styles.icon}
              onClick={() =>
                window.open(
                  "https://assets.aqar.fm/files/VAT-Certificate.pdf",
                  "_blank",
                )
              }
              width={40}
              height={40}
            />
            <DeferredIcon
              alt="rega"
              type="REGA-License"
              ext="png"
              className={styles.icon}
              onClick={() =>
                window.open(
                  "https://eservicesredp.rega.gov.sa/public/OfficesBroker/LicenseDetails/Bmlp/08daf887-9de3-4e10-8a6b-aa6cc07bf69d",
                  "_blank",
                )
              }
              width={40}
              height={40}
            />
          </div>
        </div>
        <div className={styles.copyrights}>
          كافة الحقوق محفوظة لتطبيق عقار {new Date().getFullYear()}
        </div>
        <div className={styles.copyrights}>
          شركة تطبيق عقار مرخصة من وزارة السياحة برقم 73106505
        </div>
      </div>
    </div>
  );
};

export default Footer;
